// src/screens/LoginScreen.jsx
import { useState } from "react";
import { C, globalStyles } from "../styles/tokens";
import { Icon } from "../components/UI";

export default function LoginScreen({ onLogin, onSignup }) {
  const [email,    setEmail]    = useState("admin@cityhospital.in");
  const [pass,     setPass]     = useState("password");
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [err,      setErr]      = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !pass) { setErr("Please fill all fields"); return; }
    setLoading(true);
    setErr("");
    await new Promise((r) => setTimeout(r, 1500));
    setLoading(false);
    onLogin();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `radial-gradient(ellipse at 20% 50%, rgba(198,40,40,.12) 0%, transparent 60%), ${C.surface}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <style>{globalStyles}</style>

      {/* Decorative blobs */}
      <div style={{ position: "fixed", top: -80, right: -80, width: 320, height: 320, borderRadius: "50%", background: "rgba(198,40,40,.06)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: -60, left: -60, width: 240, height: 240, borderRadius: "50%", background: "rgba(198,40,40,.04)", pointerEvents: "none" }} />

      <div className="fade-up" style={{ width: "100%", maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              width: 64, height: 64,
              background: "rgba(198,40,40,.15)",
              border: "1.5px solid rgba(198,40,40,.3)",
              borderRadius: 18,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginBottom: 16,
              animation: "pulse 2.5s ease-in-out infinite",
            }}
          >
            <Icon name="drop" size={32} color={C.red} />
          </div>
          <h1 className="syne" style={{ fontSize: 28, fontWeight: 900, color: C.text, letterSpacing: -0.5 }}>
            BloodBridge
          </h1>
          <p style={{ color: C.muted, fontSize: 13, marginTop: 4 }}>Hospital Portal · Sign In</p>
        </div>

        <div className="card" style={{ padding: 28 }}>
          <form onSubmit={submit}>
            {/* Email */}
            <div style={{ marginBottom: 16 }}>
              <label className="inp-label">Email Address</label>
              <div className="inp-wrap">
                <span className="inp-icon"><Icon name="mail" size={16} color={C.red} /></span>
                <input
                  className="inp"
                  type="email"
                  placeholder="doctor@hospital.in"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            {/* Password */}
            <div style={{ marginBottom: 8 }}>
              <label className="inp-label">Password</label>
              <div className="inp-wrap">
                <span className="inp-icon"><Icon name="lock" size={16} color={C.red} /></span>
                <input
                  className="inp"
                  type={showPass ? "text" : "password"}
                  placeholder="••••••••"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  style={{ paddingRight: 44 }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer" }}
                >
                  <Icon name={showPass ? "eyeoff" : "eye"} size={16} color={C.muted} />
                </button>
              </div>
            </div>

            {/* Forgot */}
            <div style={{ textAlign: "right", marginBottom: 20 }}>
              <button type="button" style={{ background: "none", border: "none", color: C.red, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                Forgot Password?
              </button>
            </div>

            {/* Error */}
            {err && (
              <div style={{ background: "rgba(211,47,47,.12)", border: "1px solid rgba(211,47,47,.3)", borderRadius: 10, padding: "10px 14px", color: "#EF9A9A", fontSize: 13, marginBottom: 16 }}>
                {err}
              </div>
            )}

            <button className="btn-primary" type="submit" disabled={loading}>
              {loading
                ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}><div className="spinner" /><span>Signing in...</span></div>
                : "Sign In to Portal"}
            </button>
          </form>

          <p style={{ textAlign: "center", marginTop: 20, color: C.muted, fontSize: 13 }}>
            Don't have an account?{" "}
            <button onClick={onSignup} style={{ background: "none", border: "none", color: C.red, fontWeight: 700, cursor: "pointer", fontSize: 13 }}>
              Register Hospital
            </button>
          </p>
        </div>

        <p style={{ textAlign: "center", color: C.muted, fontSize: 11, marginTop: 16 }}>
          Secured portal · BloodBridge v2.0
        </p>
      </div>
    </div>
  );
}